import styled from "styled-components";

export const RoadmapPageWrapper = styled.div``;
